import { Suspense } from 'react'
import { Navigate } from 'react-router'
import { useSubcategories } from '~/entities/categories'
import { isTaggingClassification, useCurrentDocument } from '~/entities/document'
import { DocumentReviewLayout } from '~/widgets/document-review-layout'
import { LoadingSkeleton } from './tagging/loading-skeleton'
import { Tagging } from './tagging/tagging'

export function DocumentTaggingPage() {
  const {
    data: { document },
  } = useCurrentDocument()
  const subcategories = useSubcategories()
  const isTaggingEnabled = isTaggingClassification(document?.category, subcategories)

  if (!isTaggingEnabled) {
    return (
      <Navigate
        to="/404"
        replace
      />
    )
  }

  return (
    <DocumentReviewLayout
      step="Tagging"
      loader={<LoadingSkeleton />}
    >
      <Suspense fallback={<LoadingSkeleton />}>
        <Tagging />
      </Suspense>
    </DocumentReviewLayout>
  )
}
